import type { AthenaIncomingHttpRequestIR } from "../../transport/http/incoming.ts";
import { parseAthenaIncomingHttpRequest } from "../../transport/http/incoming.ts";
import type { AthenaIngressIR } from "../ir.ts";

export function compileIngressFromIncomingHttp(input: {
	connectionId?: string;
	domain: string;
	id?: string;
	incoming: AthenaIncomingHttpRequestIR;
	operation: string;
}): AthenaIngressIR {
	const headers = input.incoming.headers;
	return {
		id: input.id ?? crypto.randomUUID(),
		domain: input.domain,
		operation: input.operation,
		transport: { kind: "http" },
		body: input.incoming.body,
		headers,
		receivedAt: new Date(),
		...(headers["x-athena-trace-id"]
			? { traceId: headers["x-athena-trace-id"] }
			: {}),
		...(headers["x-athena-correlation-id"]
			? { correlationId: headers["x-athena-correlation-id"] }
			: {}),
		...(input.connectionId ? { connectionId: input.connectionId } : {}),
	};
}

export async function compileHttpWebhookIngress(input: {
	request: Request;
	domain: string;
	operation: string;
	connectionId?: string;
	id?: string;
	maxBodyBytes?: number;
}): Promise<AthenaIngressIR> {
	const incoming = await parseAthenaIncomingHttpRequest(input.request, {
		maxBodyBytes: input.maxBodyBytes,
	});
	return compileIngressFromIncomingHttp({
		incoming,
		domain: input.domain,
		operation: input.operation,
		...(input.connectionId ? { connectionId: input.connectionId } : {}),
		...(input.id ? { id: input.id } : {}),
	});
}
